// extracted by mini-css-extract-plugin
module.exports = {"SvgWrapper":"ExternalSvg-module--SvgWrapper--16FUh"};